<ul class="c__tabs-nav" sd-list-inline>
  @for (item of items; track item) {
    <li #tabList (click)="animation === animationEnum.slide ? selectTab($index): ''">
      <!-- if item not disabled, manage template -->
      @if (!item.disabled) {
        <!-- Tabs with RouterLInk -->
        @if (!item.subNav && !item.href) {
          <a class="c__tab-nav" #rla="routerLinkActive" [routerLink]="item.routerLink" routerLinkActive="is-active" [id]="item.navId">
            {{ item.navTitle }}
          </a>
        }
        @if (item.href || item.icon) {
          <a class="c__tab-nav" [attr.href]="item.href" target="_blank" [id]="item.navId">
            @if (item.icon) {
              <sd-icon [name]="item.icon" />
            }
            <span>{{ item.navTitle }}</span>
            @if (!item.icon) {
              <sd-icon name="icon-arrow-right" />
            }
          </a>
        }
        <!-- Tabs with subnav inside a dropdown -->
        @if (item.subNav) {
          <sd-dropdown
            [isBtnSmall]="true"
            class="c__tab-nav c--dropdown {{ item.disabled ? 'is-disabled' : '' }}"
            dropdownCustomClass="dropdown-custom-class"
            dropdownCustomId="dropdownCustomId"
            #rla="routerLinkActive"
            routerLinkActive="is-active"
          >
            <ng-container sd-dropdown-button>
              {{ item.navTitle }}
            </ng-container>
            <ng-container sd-dropdown-menu>
              <ul sd-list-block>
                @for (subitem of item.subNav; track subitem) {
                  <li
                    tabindex="1"
                    class="c__option"
                    [routerLink]="subitem.routerLink"
                    routerLinkActive="is-active"
                    [id]="subitem.navId"
                    (click)="close()"
                  >
                    {{ subitem.navTitle }}
                  </li>
                }
              </ul>
            </ng-container>
          </sd-dropdown>
        }
      }
      <!-- if item IS disabled, only print text (not link) -->
      @if (item.disabled) {
        <span class="c__tab-nav is-disabled"
          [id]="item.navId">
          <span>{{ item.navTitle }}</span>
          @if (item.href) {
            <sd-icon name="icon-arrow-right" />
          }
        </span>
      }
    </li>
  }
</ul>
@if (animation === animationEnum.slide) {
  <span #activeBar class="c__active-bar"></span>
}
